module.exports = __webpack_public_path__ + "img/bg_avatar_male_42.da26c6a9.png";